export function setCurrentTab(state, tab) {
  state.currentTab = tab;
}
export function setShowMobileDetails(state, show) {
  state.showMobileDetails = show;
}
export function setIsUserLoading(state, loading) {
  state.isUserLoading = loading;
}
